import {useForm} from 'react-hook-form'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'
import Modal from '../../shared/Modal'

import {connect} from '../../../state/hooks/tools'
import {deleteResource} from '../../../lib/asyncMethods'
import {CLIENTS} from '../../../state/actionTypes'

/**
 * The confirmation a connected client goes through before it is deleted.
 *
 * Deleting a client takes its public key and webhook URL with it, so the service behind it can no
 * longer have its requests verified or hear back from us. The card's delete button only opens this
 * dialog, and the delete stays disabled until the admin types the client's name exactly — a click
 * alone is too easy to land on the wrong card.
 *
 * The dialog stays mounted between clients, so the typed name is cleared whenever it closes.
 */
const DeleteClient = props => {
  const methods = useForm({defaultValues: {confirmation: ''}})
  const nameConfirmed = methods.watch('confirmation') === props.client.name

  const close = () => {
    methods.reset()
    props.toggleModal()
  }

  const destroy = () => {
    props.deleteResource(`clients/${props.client.id}`).then(response => {
      if (response.success)
        close()
    })
  }

  return (
    <Modal
      open={props.showModal}
      handleClose={close}
      disabled={props.loading}
      maxWidth='sm'
      buttonText='Cancel'
      title={`Delete ${props.client.name}?`}>
        <Stack>
          <Typography gutterBottom>
            {props.client.name} will stop working with this service: requests it signs are no longer
            verified, and its webhook stops receiving updates.
          </Typography>
          <Alert className='notice' severity='error'>
            It cannot be undone. Connecting it again means creating a new client with its keys and URLs.
          </Alert>
          <FormWrapper methods={methods} handleSubmit={destroy}>
            <Input
              label={`Type "${props.client.name}" to confirm`}
              name='confirmation'
              margin='dense'
            />
            <Button
              disabled={props.loading || !nameConfirmed}
              type='submit'
              variant='contained'
              color='error'>
              Delete
            </Button>
          </FormWrapper>
        </Stack>
    </Modal>
  )
}

const mapStateToProps = ({clients}) => ({loading: clients.loading})

const actionCreators = ({clients}) => ({deleteResource: deleteResource(clients, CLIENTS)})

export default connect(mapStateToProps, actionCreators)(DeleteClient)
